import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project.list');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-page-project-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.project.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageProjectListComponent implements OnInit {
    public is_add_project: boolean = false;
    public list: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 10;
    public searchText: string = '';
    public stats: any = { total: 0, in_progress: 0, scheduled: 0, completed: 0 };
    public canCreateProject: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.init(this);

        try {
            const urlParams = new URLSearchParams(window.location.search);
            const queryPage = urlParams.get('page');
            if (queryPage) this.page = parseInt(queryPage);
        } catch (e) { }

        await this.load(this.page);
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async load(page: number = 1) {
        this.page = Math.max(1, page);

        try {
            const url = new URL(window.location.href);
            url.searchParams.set('page', String(this.page));
            window.history.replaceState({}, '', url.toString());
        } catch (e) { }

        const { code, data } = await wiz.call('list', { page: this.page, dump: this.dump, text: this.searchText });
        if (code === 200) {
            this.list = data.list || [];
            this.total = data.total || 0;
            this.stats = data.stats || { total: 0, in_progress: 0, scheduled: 0, completed: 0 };
            this.canCreateProject = !!data.can_create_project;
        }
        window.scrollTo(0, 0);
        this.ref.detectChanges();
    }

    public get pages(): number[] {
        const totalPages = Math.ceil(this.total / this.dump);
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    public viewDetail(id: string) {
        this.service.href(`/project/detail/${id}`);
    }

    public async addProject() {
        if (!this.canCreateProject) return;
        this.is_add_project = true;
        this.ref.detectChanges();
    }

    public async onModalClose(success: boolean) {
        this.is_add_project = false;
        if (success) await this.load();
        this.ref.detectChanges();
    }

    public async onSearch() {
        await this.load(1);
    }

    public async deleteProject(id: string) {
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 용역을 삭제하시겠습니까? 관련된 도면과 시설물도 함께 삭제됩니다.',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;

        await this.service.loading.show();
        const { code, data } = await wiz.call('delete', { id });
        await this.service.loading.hide();

        if (code === 200) {
            await this.service.alert.show({
                title: '삭제 완료',
                message: '용역이 삭제되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
            await this.load();
        } else {
            await this.service.alert.show({
                title: '삭제 실패',
                message: data || '삭제에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }
    }
}

export default PageProjectListComponent;